import { Component, OnInit } from '@angular/core';
import { CashBankTransactionService} from 'app/shared/services/cash-bank-transaction.service';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-cash-flow',
  templateUrl: './cash-flow.component.html',
  styleUrls: ['./cash-flow.component.css']
})
export class CashFlowComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  isDark: boolean = false;

  fromDate : Date;
  toDate : Date;
  bankAccount =null;
  openingBalance = 0.00;
  openingBalText ;
  closingBalText ;


  receipts :any[];
  payment :any[];
  expense :any[];
  cashDebit :any[];
  cashCredit :any[];
  joinArray = [];
  finalArray = [];
  filteredList =[];
  bankAccountList = [];
  allTransactionData = [];

  constructor(
               private cashBankTransactionService :CashBankTransactionService, 
               private bankAccountsService:BankAccountsService,
               private router : Router, 
               private themeService: NbThemeService,
               private decimalPipe : DecimalPipe
              ) 
              { 

                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }

  ngOnInit(): void {

    this.getBankAccountList();
    this.getAllCashBal();


    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {
                  this.bankAccountList = data;
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

     getAllCashBal(){

      this.cashBankTransactionService.getAllCashBal()
      .subscribe(
         (data) => {
                   this.allTransactionData = data;
                   this.mapCashTransactions(this.allTransactionData);
                   },
        (err) => 
                 {
                   if(err instanceof HttpErrorResponse){                 
                     if(err.status == 401){
                       this.router.navigate(['/login']);
                     }
                   }
                   console.log(err);
                 });  

     }


     mapCashTransactions(data){
	 
      this.receipts = data.receiptData.map((obj)=>{
              return{transNo: obj.ReceiptNo,createdBy: obj.CreatedBy,  transType : 'Receipt', 
              transDate: new Date(obj.PaidDate),paymentType: obj.PaymentType,description: obj.CusName,
              cash_bank_account: obj.DepositAccount, payRefNo: obj.PayRefNo, amount: obj.PaidTotal};
                });
              
      this.payment  = data.paymentData.map((obj)=>{
                        return {transNo: obj.VoucherNo,createdBy: obj.CreatedBy, transType : 'Payment',
              transDate: new Date(obj.PaidDate), paymentType: obj.PaymentType, description: obj.SupName,        
              cash_bank_account: obj.PaymentAccount, payRefNo: obj.PayRefNo,amount: (obj.PaidTotal *-1)}                                          
                        });		
                    
                              
                            
        this.expense = data.expData.map((obj)=>{
                       return {transNo: obj.ExpNo,createdBy: obj.CreatedBy, transType : 'Expense',
               transDate: new Date(obj.ExpDate),paymentType: obj.PaymentType, description: obj.ExpName+'-'+obj.ExpCategory,                                 
               cash_bank_account: obj.PaymentAccount,payRefNo: obj.PayRefNo,amount: (obj.ExpTotal*-1)};                                  
                       }); 
    
        this.cashDebit = data.cashData.map((obj)=>{
               return {transNo: obj.TransNo,createdBy: obj.CreatedBy,transType : obj.TransType,
               transDate: new Date(obj.TransDate),paymentType: 'To',description: obj.Description,		
               cash_bank_account: obj.ToAccount,payRefNo: '',amount: (obj.Amount)};		
               });  
                
      this.cashCredit = data.cashData.map((obj)=>{
               return {transNo: obj.TransNo,createdBy: obj.CreatedBy,transType : obj.TransType,
               transDate: new Date(obj.TransDate),paymentType: 'From',description: obj.Description,		
               cash_bank_account: obj.FromAccount,payRefNo: '',amount: (obj.Amount*-1)};		
               }); 
               
    
          this.joinArray.push(...this.receipts,...this.payment,...this.expense,...this.cashDebit,...this.cashCredit);
          this.finalArray =this.joinArray;
         // this.finalArray =this.joinArray.map(item=>Object.values(item));
               
          this.finalArray.sort((a, b) => a.transDate - b.transDate);
         
          this.filteredList=   this.finalArray;  
          this.getOpeningBalance(this.finalArray,null,null)  					 
                              
                             
          } 

 

    getOpeningBalance(array,startDate,bankAccount){
      var openingBalData;
      var uptoDateBalData;
 
      if(startDate && bankAccount){

        openingBalData = this.bankAccountList.filter(data => {              
          return  data.AccountName?.toLowerCase().indexOf(bankAccount.trim().toLowerCase()) !==-1;        
          });


      this.openingBalance = +openingBalData[0].OpeningBal;

      uptoDateBalData= array.filter(data => {
        var getDate = moment(data.transDate).format("YYYY-MM-DD");              
        return moment(getDate).isBefore(startDate) && 
        data.cash_bank_account?.toLowerCase()===bankAccount.trim().toLowerCase();
        });

        this.openingBalance += uptoDateBalData.map(totalBal=>totalBal.amount).reduce((acc,value)=>acc + +value,0);
      }
      else if(startDate){
        this.openingBalance = this.bankAccountList.map(totalBal=>totalBal.OpeningBal).reduce((acc,value)=>acc + +value,0);

        uptoDateBalData= array.filter(data => {
          var getDate = moment(data.transDate).format("YYYY-MM-DD");              
          return moment(getDate).isBefore(startDate);        
          });


          this.openingBalance += uptoDateBalData.map(totalBal=>totalBal.amount).reduce((acc,value)=>acc + +value,0);
      }
      else if(bankAccount){
          openingBalData = this.bankAccountList.filter(data => {              
          return  data.AccountName.toLowerCase()===bankAccount.trim().toLowerCase();        
          });

          this.openingBalance =openingBalData[0].OpeningBal;

        uptoDateBalData= array.filter(data => {             
          data.cash_bank_account.toLowerCase()===bankAccount.trim().toLowerCase();       
          });

          this.openingBalance += uptoDateBalData.map(totalBal=>totalBal.amount).reduce((acc,value)=>acc + +value,0);
      }
      else{

        this.openingBalText = 'of all account';
        this.closingBalText  = 'of all account';
        this.openingBalance = this.bankAccountList.map(totalBal=>totalBal.OpeningBal).reduce((acc,value)=>acc + +value,0);
      }
    }


    getTotal(){
      return this.filteredList.map(totalBal=>totalBal.amount).reduce((acc,value)=>acc + +value,+this.openingBalance);
    }



      viewBtnClicked(){
        if(this.fromDate && this.toDate && this.bankAccount){
            var startDate =moment(this.fromDate).format("YYYY-MM-DD");
            var endDate =moment(this.toDate).format("YYYY-MM-DD");
            this.openingBalText = `as at ${startDate}`;
            this.closingBalText = `as at ${endDate}`;   
            this.filteredList = this.finalArray.filter(data => {
                  var expDate = moment(data.transDate).format("YYYY-MM-DD");              
                  return moment(expDate).isBetween(startDate, endDate,undefined,'[]') && 
                  data.cash_bank_account?.toLowerCase()===this.bankAccount.trim().toLowerCase();
                  });
                  console.log(this.filteredList);

                  

              this.getOpeningBalance(this.finalArray,startDate,this.bankAccount)
        }
        
        else if(this.fromDate && this.toDate){
          var startDate =moment(this.fromDate).format("YYYY-MM-DD");
          var endDate =moment(this.toDate).format("YYYY-MM-DD");
          this.openingBalText = `of all account as at ${startDate}`;
          this.closingBalText  = `of all account as at ${endDate}`;  
     
          this.filteredList = this.finalArray.filter(data => {
                var expDate = moment(data.transDate).format("YYYY-MM-DD");              
                return moment(expDate).isBetween(startDate, endDate,undefined,'[]');              
                });

                this.getOpeningBalance(this.finalArray,startDate,null)
          }

        else if(this.bankAccount){
          this.openingBalText = '';
          this.closingBalText  = '';   
          this.filteredList= this.finalArray.filter(data => {                        
                 return data.cash_bank_account.toLowerCase()===this.bankAccount.trim().toLowerCase();            
                });

              this.getOpeningBalance(this.finalArray,null,this.bankAccount);
        }

      }

      clearBtnClicked(){
        this.fromDate = null;
        this.toDate = null;
        this.bankAccount  = null;
        this.filteredList =   this.finalArray;  
        this.getOpeningBalance(this.finalArray,null,null)
  
       }

       savePDF(action){

        const documentDefinition = { 
          pageSize: 'A4',
          pageOrientation: 'landscape',
  
          content: [   
            { text: 'Cash Flow Statement', style: 'reportHeader' }, 
            { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0,5,0,5] }, 
             
                       
            {  
              table: {  
                  headerRows: 1,  
                  widths: ['auto','auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto'],  
                  body: [  
                    
                    ['TransNo','CreatedBy', 'Type', 'Date', 'PaymentTyp', 'Description','Account', 'RefNo', 'Amount'],
                    [ { text: `Opening Balance  ${this.openingBalText}`, bold: true, colSpan: 8 }, {},{},{},{},{},{},{}, { text :  this.transformNumberFormat(this.openingBalance),alignment: 'right', bold : true } ],  
                   ...this.filteredList.map(p => ([p.transNo,p.createdBy,p.transType,moment(p.transDate).format("YYYY-MM-DD"),p.paymentType,p.description,p.cash_bank_account,(p.payRefNo ? p[7] : ''),{text : this.transformNumberFormat(p.amount), alignment: 'right'  } ])),   
                    [ { text: `Closing Balance ${this.closingBalText}`, bold: true, colSpan: 8 }, {},{},{},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotal()),alignment: 'right', bold : true } ]  
                  ]           
            }
          }
          ],
          styles: {  
            reportHeader: {  
                bold: true,  
                decoration: 'underline',  
                fontSize: 14,  
                margin: [0, 15, 0, 10],
                alignment: 'center',             
            }  
          }  
         };
  
          if(action==='open'){    
                pdfMake.createPdf(documentDefinition).open();  
            }else if(action === 'print'){    
                pdfMake.createPdf(documentDefinition).print();          
            }
       }
  

      exportexcel(): void 
      {
         /* table id is passed over here */   
         let element = document.getElementById('expReport'); 
         const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
         /* generate workbook and add the worksheet */
         const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
         /* save to file */
         XLSX.writeFile(wb, 'Cash Flow Statement.xlsx');
        
      }
 
      transformNumberFormat(number) {
       return this.decimalPipe.transform(number,'1.2-2');
    }
 

}
